export const visit = (vm, at) => {
vm(require("documents-lib/lang/view/af.lyaml"));
at({ "af": { "public": { "sampleString": "Voorbeeldstring" } } });
};